import { render } from "./ModalCertifications.vue?vue&type=template&id=7dde26be"
import script from "./ModalCertifications.vue?vue&type=script&lang=js"
export * from "./ModalCertifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__